"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var Settings = /*#__PURE__*/function () {
  function Settings(opt) {
    _classCallCheck(this, Settings);

    this._id = null;
    this.hasLoggedIn = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Settings, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = opt._id;
      this.hasLoggedIn = opt.hasLoggedIn;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Settings.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'settings.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'string'
          },
          hasLoggedIn: {
            type: 'boolean'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Settings;
}();

module.exports = Settings;